module.exports = __webpack_public_path__ + "static/media/my-flag-small.f56c58c5.svg";